export default [
	//待入库商品
	{
		path: 'wait-in-stock',
		name: 'm_wait_storage',
		props: route => route.params,
		component: () => import('@/pages/storage/wait_in_stock_code_list')
	},
	//库存余额
	{
		path: 'stock-balance',
		name: 'm_storage_balance',
		props: route => route.params,
		component: () => import('@/pages/storage/stock_balance_code_list')
	},
	//库存台账
	{
		path: 'ledger',
		name: 'm_storage_ledger',
		props: route => route.params,
		component: () => import('@/pages/storage/ledger_unique_code_list')
	},
	//高库龄预警
	{
		path: 'high-stock-age',
		name: 'm_high_stock_age',
		props: route => route.params,
		component: () => import('@/pages/storage/high_stock_age_code_list')
	},
	//库存分布
	{
		path: 'stock-distribution',
		name: 'm_storage_distribution',
		props: route => route.params,
		component: () => import('@/pages/storage/storage_distribution_list')
	},
	//设备停留时长
	{
		path: 'stock-stay-duration',
		name: 'm_storage_stay_duration',
		props: route => route.params,
		component: () => import('@/pages/storage/storage_stay_duration_list')
	},
	//库存盘点
	{
		path: 'inventory',
		name: 'm_inventory',
		props: route => route.params,
		component: () => import('@/pages/storage/inventory_list')
	},
	//电子货架
	{
		path: 'electronic-shelf',
		name: 'm_electronic_shelf',
		props: route => route.params,
		component: () => import('@/pages/storage/electronic_shelf_list')
	},
	//调拨对象管理
	{
		path: 'profit-transfer-merchant',
		name: 'm_profit_merchant',
		props: route => route.params,
		component: () => import('@/pages/storage/profit_merchant_list')
	},
	//分润调拨
	{
		path: 'profit-transfer',
		name: 'm_profit_transfer',
		props: route => route.params,
		component: () => import('@/pages/storage/profit_transfer_list')
	},
	//分润调拨明细
	{
		path: 'profit-transfer-item',
		name: 'm_profit_transfer_item',
		props: route => route.params,
		component: () => import('@/pages/storage/profit_transfer_item_list')
	},
	//分润调拨退货
	{
		path: 'profit-transfer-return',
		name: 'm_profit_transfer_return',
		props: route => route.params,
		component: () => import('@/pages/storage/profit_return_list')
	}
];
